import { IApplicationError } from '../shared/application-error';

export interface RespondentTokenValidationModel {
    tokenValue: string;
    hasPassword: boolean;
    tokenValidationErrorType: number;
    locale: string;
    languageId: number;
    applicationError: IApplicationError;
    participantName: string;
    participantEmailAddress: string;
    otac: string;
}
